import { useEffect, useState } from "react";
import { BRAND } from "@/lib/constants";

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const navItems = [
        { label: "Problema", id: "problema" },
        { label: "Solución", id: "solucion" },
        { label: "Autoridad", id: "autoridad" },
        { label: "Beneficios", id: "beneficios" },
        { label: "Curso gratis", id: "curso" },
    ];

    return (
        <header
            data-testid="navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-[#F7F3EE]/85 backdrop-blur-xl border-b border-[#1E1E1E]/8"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 flex items-center justify-between h-20">
                <a
                    href="#top"
                    data-testid="navbar-logo"
                    className="flex items-center gap-3 group"
                >
                    <img
                        src={BRAND.logo}
                        alt="Hewser Personal Branding"
                        className="h-10 w-10 object-contain"
                    />
                    <div className="hidden sm:flex flex-col leading-tight">
                        <span className="font-display text-[15px] tracking-wide text-[#1E1E1E]">
                            Hewser
                        </span>
                        <span className="font-italic-display text-[11px] text-[#8C7C72] tracking-wider">
                            Personal Branding
                        </span>
                    </div>
                </a>

                <nav className="hidden lg:flex items-center gap-10">
                    {navItems.map((item) => (
                        <a
                            key={item.id}
                            href={`#${item.id}`}
                            data-testid={`nav-link-${item.id}`}
                            className="text-[12px] tracking-[0.18em] uppercase text-[#1E1E1E]/75 hover:text-[#C6A76A] transition-colors duration-300"
                        >
                            {item.label}
                        </a>
                    ))}
                </nav>

                <a
                    href="#contacto"
                    data-testid="navbar-cta-contact"
                    className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 border border-[#1E1E1E] rounded-full text-[11px] tracking-[0.2em] uppercase text-[#1E1E1E] hover:bg-[#1E1E1E] hover:text-[#F7F3EE] transition-all duration-300"
                >
                    Diagnóstico
                </a>

                <button
                    type="button"
                    aria-label="Abrir menú"
                    data-testid="navbar-mobile-toggle"
                    onClick={() => setOpen((s) => !s)}
                    className="lg:hidden flex flex-col gap-1.5 p-2"
                >
                    <span className={`block w-6 h-px bg-[#1E1E1E] transition-transform ${open ? "translate-y-2 rotate-45" : ""}`} />
                    <span className={`block w-6 h-px bg-[#1E1E1E] transition-opacity ${open ? "opacity-0" : ""}`} />
                    <span className={`block w-6 h-px bg-[#1E1E1E] transition-transform ${open ? "-translate-y-2 -rotate-45" : ""}`} />
                </button>
            </div>

            {open && (
                <div
                    data-testid="navbar-mobile-menu"
                    className="lg:hidden bg-[#F7F3EE] border-t border-[#1E1E1E]/10 px-6 py-8"
                >
                    <nav className="flex flex-col gap-5">
                        {navItems.map((item) => (
                            <a
                                key={item.id}
                                href={`#${item.id}`}
                                data-testid={`nav-link-mobile-${item.id}`}
                                onClick={() => setOpen(false)}
                                className="text-sm tracking-[0.18em] uppercase text-[#1E1E1E]/80 hover:text-[#C6A76A]"
                            >
                                {item.label}
                            </a>
                        ))}
                        <a
                            href="#contacto"
                            data-testid="nav-link-mobile-contacto"
                            onClick={() => setOpen(false)}
                            className="text-sm tracking-[0.18em] uppercase text-[#C6A76A]"
                        >
                            Diagnóstico
                        </a>
                    </nav>
                </div>
            )}
        </header>
    );
}
